(ns ui.icons
  (:require
   [reagent.core :as r]
   ["lucide-react" :refer [Ban Calendar Check CircleCheck ChevronDown ChevronRight ChevronUp
                           ChevronsLeft ChevronsRight EllipsisVertical ExternalLink Eye EyeOff
                           GripVertical LoaderCircle Lock Maximize2 Minimize2 PanelLeftIcon Pause
                           Pencil Plus RefreshCw Search Sparkles TriangleAlert Trash2 X]]))

(def adapt r/adapt-react-class)

(def ban-icon (adapt Ban))

(def calendar-icon (adapt Calendar))

(def check-icon (adapt Check))

(def circle-check-icon (adapt CircleCheck))

(def loader-circle-icon (adapt LoaderCircle))

(def triangle-alert-icon (adapt TriangleAlert))

(def chevron-down-icon (adapt ChevronDown))

(def chevron-right-icon (adapt ChevronRight))

(def chevron-up-icon (adapt ChevronUp))

(def chevrons-left-icon (adapt ChevronsLeft))

(def chevrons-right-icon (adapt ChevronsRight))

(def ellipsis-vertical-icon (adapt EllipsisVertical))

(def external-link-icon (adapt ExternalLink))

(def eye-icon (adapt Eye))

(def eye-off-icon (adapt EyeOff))

(def grip-vertical-icon (adapt GripVertical))

(def lock-icon (adapt Lock))

(def maximize-icon (adapt Maximize2))

(def minimize-icon (adapt Minimize2))

(def panel-left-icon (adapt PanelLeftIcon))

(def pause-icon (adapt Pause))

(def pencil-icon (adapt Pencil))

(def plus-icon (adapt Plus))

(def refresh-icon (adapt RefreshCw))

(def search-icon (adapt Search))

(def sparkles-icon (adapt Sparkles))

(def trash-icon (adapt Trash2))

(def x-icon (adapt X))
